import { RouterProvider } from 'react-router-dom';
import { router } from './routes';

// Auth and data-fetching providers (Amplify, TanStack Query) land in later PRs.
export default function App() {
  return <RouterProvider router={router} />;
}
